import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${semantic.border.default};
  border-radius: 24px;
  overflow: hidden;
`;

export const StepButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space[8]};
  height: ${space[8]};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  padding: 0;
  transition: opacity 0.15s ease;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.7;
  }
`;

export const Value = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  min-width: ${space[6]};
  text-align: center;
  padding: 0 ${space[1]};
`;
